import {
    SiteLinkField,
    SiteLinkFieldData
} from '../../components/SiteLink/SiteLink';
import { BannerId, BannersEditData, SiteLinkData } from '../../typings/banners';
import { ProtocolValue } from '../../typings/bannersEditState';
import { ValidationResultItem } from '../../typings/common';

export const OPEN_SITE_LINKS_EDITOR = 'OPEN_SITE_LINKS_EDITOR';
export type OPEN_SITE_LINKS_EDITOR = typeof OPEN_SITE_LINKS_EDITOR;
export interface OpenSiteLinksEditor {
    type: OPEN_SITE_LINKS_EDITOR;
    bannerId: BannerId;
}
export function openSiteLinksEditor(bannerId: BannerId): OpenSiteLinksEditor {
    return {
        type: OPEN_SITE_LINKS_EDITOR,
        bannerId
    };
}

export const CLOSE_SITE_LINKS_EDITOR = 'CLOSE_SITE_LINKS_EDITOR';
export type CLOSE_SITE_LINKS_EDITOR = typeof CLOSE_SITE_LINKS_EDITOR;
export interface CloseSiteLinksEditor {
    type: CLOSE_SITE_LINKS_EDITOR;
    bannerId: BannerId;
}
export function closeSiteLinksEditor(bannerId: BannerId): CloseSiteLinksEditor {
    return {
        type: CLOSE_SITE_LINKS_EDITOR,
        bannerId
    };
}

export const OPEN_SITE_LINKS_CANVAS = 'OPEN_SITE_LINKS_CANVAS';
export type OPEN_SITE_LINKS_CANVAS = typeof OPEN_SITE_LINKS_CANVAS;
export interface OpenSiteLinksCanvas {
    type: OPEN_SITE_LINKS_CANVAS;
    bannerId: BannerId;
    index: number;
}

export function openSiteLinksCanvas(
    bannerId: BannerId,
    index: number
): OpenSiteLinksCanvas {
    return {
        type: OPEN_SITE_LINKS_CANVAS,
        bannerId,
        index
    };
}

export const CLOSE_SITE_LINKS_CANVAS = 'CLOSE_SITE_LINKS_CANVAS';
export type CLOSE_SITE_LINKS_CANVAS = typeof CLOSE_SITE_LINKS_CANVAS;
export interface CloseSiteLinksCanvas {
    type: CLOSE_SITE_LINKS_CANVAS;
    bannerId: BannerId;
}
export function closeSiteLinksCanvas(bannerId: BannerId): CloseSiteLinksCanvas {
    return {
        type: CLOSE_SITE_LINKS_CANVAS,
        bannerId
    };
}

export const UPDATE_DRAFT_SITE_LINKS = 'UPDATE_DRAFT_SITE_LINKS';
export type UPDATE_DRAFT_SITE_LINKS = typeof UPDATE_DRAFT_SITE_LINKS;
export interface UpdateDraftSiteLinks {
    type: UPDATE_DRAFT_SITE_LINKS;
    bannerId: BannerId;
    index: number;
    field: SiteLinkField;
    value: SiteLinkFieldData;
}
export function updateDraftSiteLinks(
    bannerId: BannerId,
    index: number,
    field: SiteLinkField,
    value: SiteLinkFieldData
): UpdateDraftSiteLinks {
    return {
        type: UPDATE_DRAFT_SITE_LINKS,
        bannerId,
        index,
        field,
        value
    };
}

export const UPDATE_PROTOCOL_DRAFT_SITE_LINKS =
    'UPDATE_PROTOCOL_DRAFT_SITE_LINKS';
export type UPDATE_PROTOCOL_DRAFT_SITE_LINKS = typeof UPDATE_PROTOCOL_DRAFT_SITE_LINKS;
export interface UpdateProtocolDraftSiteLinks {
    type: UPDATE_PROTOCOL_DRAFT_SITE_LINKS;
    bannerId: BannerId;
    index: number;
    value: ProtocolValue;
}
export function updateProtocolDraftSiteLinks(
    bannerId: BannerId,
    index: number,
    value: ProtocolValue
): UpdateProtocolDraftSiteLinks {
    return {
        type: UPDATE_PROTOCOL_DRAFT_SITE_LINKS,
        bannerId,
        index,
        value
    };
}

export const UPDATE_SITE_LINKS = 'UPDATE_SITE_LINKS';
export type UPDATE_SITE_LINKS = typeof UPDATE_SITE_LINKS;
export interface UpdateSiteLinks {
    type: UPDATE_SITE_LINKS;
    bannerId: BannerId;
}
export function updateSiteLinks(bannerId: BannerId): UpdateSiteLinks {
    return {
        type: UPDATE_SITE_LINKS,
        bannerId
    };
}

export const TOGGLE_SITE_LINKS_DESCRIPTION_FLAG =
    'TOGGLE_SITE_LINKS_DESCRIPTION_FLAG';
export type TOGGLE_SITE_LINKS_DESCRIPTION_FLAG = typeof TOGGLE_SITE_LINKS_DESCRIPTION_FLAG;
export interface ToggleSiteLinksDescriptionFlag {
    type: TOGGLE_SITE_LINKS_DESCRIPTION_FLAG;
    bannerId: BannerId;
}
export function toggleSiteLinksDescriptionFlag(
    bannerId: BannerId
): ToggleSiteLinksDescriptionFlag {
    return {
        type: TOGGLE_SITE_LINKS_DESCRIPTION_FLAG,
        bannerId
    };
}

export const RESET_SITE_LINKS = 'RESET_SITE_LINKS';
export type RESET_SITE_LINKS = typeof RESET_SITE_LINKS;
export interface ResetSiteLinks {
    type: RESET_SITE_LINKS;
    bannerId: BannerId;
}
export function resetSiteLinks(bannerId: BannerId): ResetSiteLinks {
    return {
        type: RESET_SITE_LINKS,
        bannerId
    };
}

export const UPDATE_SITE_LINK_HREF_STATUS = 'UPDATE_SITE_LINK_HREF_STATUS';
export type UPDATE_SITE_LINK_HREF_STATUS = typeof UPDATE_SITE_LINK_HREF_STATUS;
export interface UpdateSiteLinkHrefStatus {
    type: UPDATE_SITE_LINK_HREF_STATUS;
    bannerId: BannerId;
    index: number;
    isValid: boolean;
    text: string;
}
export function updateSiteLinkHrefStatus(
    bannerId: BannerId,
    index: number,
    isValid: boolean,
    text: string
): UpdateSiteLinkHrefStatus {
    return {
        type: UPDATE_SITE_LINK_HREF_STATUS,
        index,
        bannerId,
        isValid,
        text
    };
}

export const SAVE_SITE_LINKS = 'SAVE_SITE_LINKS';
export type SAVE_SITE_LINKS = typeof SAVE_SITE_LINKS;
export interface SaveSiteLinks {
    type: SAVE_SITE_LINKS;
    bannerId: BannerId[];
}
export function saveSiteLinks(bannerId: BannerId[]): SaveSiteLinks {
    return {
        type: SAVE_SITE_LINKS,
        bannerId
    };
}

export const SAVE_SITE_LINKS_SUCCESS = 'SAVE_SITE_LINKS_SUCCESS';
export type SAVE_SITE_LINKS_SUCCESS = typeof SAVE_SITE_LINKS_SUCCESS;
export interface SaveSiteLinksSuccess {
    type: SAVE_SITE_LINKS_SUCCESS;
    bannerId: BannerId[];
    sitelinksSetId: string[];
    collapsedSiteLinks: Array<Array<SiteLinkData>>;
}
export function saveSiteLinksSuccess(
    sitelinksSetId: string[],
    collapsedSiteLinks: Array<Array<SiteLinkData>>,
    bannerId: BannerId[]
): SaveSiteLinksSuccess {
    return {
        type: SAVE_SITE_LINKS_SUCCESS,
        bannerId,
        sitelinksSetId,
        collapsedSiteLinks
    };
}

export const SHOW_SITE_LINKS_ERRORS = 'SHOW_SITE_LINKS_ERRORS';
export type SHOW_SITE_LINKS_ERRORS = typeof SHOW_SITE_LINKS_ERRORS;
export interface ShowSiteLinksErrors {
    type: SHOW_SITE_LINKS_ERRORS;
    bannerId: BannerId[];
    collapsedSiteLinks: Array<Array<SiteLinkData>>;
    errors: ValidationResultItem[][];
}
export function showSiteLinksErrors(
    bannerId: BannerId[],
    collapsedSiteLinks: Array<Array<SiteLinkData>>,
    errors: ValidationResultItem[][]
): ShowSiteLinksErrors {
    return {
        type: SHOW_SITE_LINKS_ERRORS,
        bannerId,
        collapsedSiteLinks,
        errors
    };
}

export const CLEAR_SITE_LINKS = 'CLEAR_SITE_LINKS';
export type CLEAR_SITE_LINKS = typeof CLEAR_SITE_LINKS;
export interface ClearSiteLinks {
    type: CLEAR_SITE_LINKS;
    bannerId: BannerId[];
}
export function clearSiteLinks(bannerId: BannerId[]): ClearSiteLinks {
    return {
        type: CLEAR_SITE_LINKS,
        bannerId
    };
}

export const CHECK_BANNER_SITELINK_HREF_STATUS =
    'CHECK_BANNER_SITELINK_HREF_STATUS';
export type CHECK_BANNER_SITELINK_HREF_STATUS = typeof CHECK_BANNER_SITELINK_HREF_STATUS;
export interface CheckBannerSitelinkHrefStatus {
    type: CHECK_BANNER_SITELINK_HREF_STATUS;
    bannerId: BannerId;
    index: number;
    href: string;
}
export function checkBannerSitelinkHrefStatus(
    bannerId: BannerId,
    index: number,
    href: string
): CheckBannerSitelinkHrefStatus {
    return {
        type: CHECK_BANNER_SITELINK_HREF_STATUS,
        bannerId,
        index,
        href
    };
}

export const RESET_BANNER_SITELINK_FIELDS = 'RESET_BANNER_SITELINK_FIELDS';
export type RESET_BANNER_SITELINK_FIELDS = typeof RESET_BANNER_SITELINK_FIELDS;
export interface ResetBannerSitelinkFieldsAction {
    type: RESET_BANNER_SITELINK_FIELDS;
    bannerId: BannerId;
}
export function resetBannerSitelinkFields(
    bannerId: BannerId
): ResetBannerSitelinkFieldsAction {
    return {
        type: RESET_BANNER_SITELINK_FIELDS,
        bannerId
    };
}

export const ADD_BANNER_SITELINK = 'ADD_BANNER_SITELINK';
export type ADD_BANNER_SITELINK = typeof ADD_BANNER_SITELINK;

export interface AddBannerSiteLink {
    type: ADD_BANNER_SITELINK;
    bannerId: BannerId;
}

export function addBannerSiteLink(bannerId: BannerId): AddBannerSiteLink {
    return {
        type: ADD_BANNER_SITELINK,
        bannerId
    };
}

export const REMOVE_BANNER_SITELINK = 'REMOVE_BANNER_SITELINK';
export type REMOVE_BANNER_SITELINK = typeof REMOVE_BANNER_SITELINK;

export interface RemoveBannerSiteLink {
    type: REMOVE_BANNER_SITELINK;
    bannerId: BannerId;
    index: number;
}

export function removeBannerSiteLink(
    bannerId: BannerId,
    index: number
): RemoveBannerSiteLink {
    return {
        type: REMOVE_BANNER_SITELINK,
        bannerId,
        index
    };
}

export const CREATE_SITE_LINKS_DRAFT_DATA = 'CREATE_SITE_LINKS_DRAFT_DATA';
export type CREATE_SITE_LINKS_DRAFT_DATA = typeof CREATE_SITE_LINKS_DRAFT_DATA;

export interface CreateSiteLinksDraftDataAction {
    type: CREATE_SITE_LINKS_DRAFT_DATA;
    bannersData: BannersEditData;
}

export function createSiteLinksDraftData(
    bannersData: BannersEditData
): CreateSiteLinksDraftDataAction {
    return {
        type: CREATE_SITE_LINKS_DRAFT_DATA,
        bannersData
    };
}

export type BannersSitelinksActions =
    | OpenSiteLinksEditor
    | CloseSiteLinksEditor
    | OpenSiteLinksCanvas
    | CloseSiteLinksCanvas
    | UpdateDraftSiteLinks
    | CheckBannerSitelinkHrefStatus
    | UpdateSiteLinks
    | ToggleSiteLinksDescriptionFlag
    | ResetSiteLinks
    | UpdateSiteLinkHrefStatus
    | ShowSiteLinksErrors
    | SaveSiteLinksSuccess
    | CreateSiteLinksDraftDataAction
    | SaveSiteLinks
    | ClearSiteLinks
    | ResetBannerSitelinkFieldsAction
    | UpdateProtocolDraftSiteLinks
    | RemoveBannerSiteLink
    | AddBannerSiteLink;
